// src/components/analytics/AnalyticsModal.jsx
import React, { useEffect, useState } from "react";
import "./analytics-modal.css";

export default function AnalyticsModal({ open, onClose }) {
  const [summary, setSummary] = useState(null);
  const [, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fmt = (n) => (n == null ? "—" : Intl.NumberFormat().format(n));

  useEffect(() => {
    if (!open) return;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const rawTZ = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
        const tz = encodeURIComponent(rawTZ);
        const today = new Date().toLocaleDateString("en-CA", { timeZone: rawTZ });
        const qsAgg = `period=custom&date=${today},${today}&timezone=${tz}`;
        const sRes = await fetch(`/api/analytics/summary?${qsAgg}`, { cache: "no-store" });
        const s = await sRes.json();
        if (!sRes.ok || s?.error) throw new Error(`summary: ${JSON.stringify(s?.body || s)}`);
        setSummary(s);
      } catch (e) {
        setError(e?.message || "Failed to load analytics");
        setSummary(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [open]);

  if (!open) return null;

  const agg = summary?.results || {};

  return (
    <div className="amodal__backdrop" onClick={onClose}>
      <div className="amodal" onClick={(e)=>e.stopPropagation()}>
        <div className="amodal__header">
          <h3>Site Analytics — Today</h3>
          <button className="amodal__close" onClick={onClose}>×</button>
        </div>

        {error && <div className="amodal__error">⚠️ {error}</div>}

        <div className="amodal__stats">
          <div className="stat"><div>Visitors</div><b>{fmt(agg.visitors?.value)}</b></div>
          <div className="stat"><div>Pageviews</div><b>{fmt(agg.pageviews?.value)}</b></div>
          <div className="stat"><div>Bounce</div><b>{agg.bounce_rate?.value != null ? Number(agg.bounce_rate.value).toFixed(0) + "%" : "—"}</b></div>
          <div className="stat"><div>Visit duration</div><b>{agg.visit_duration?.value != null ? Math.round(agg.visit_duration.value/60)+"m" : "—"}</b></div>
        </div>

        {}
      </div>
    </div>
  );
}
